import axios from "axios";
import {of, from} from "rxjs";
import {map, catchError, first} from "rxjs/operators";
import '../../constants';

//    ============== WARNING ================
//    Race condition with multiple validation
//    =======================================

/*
   <(^_^)> Bryan Perez

   RETURNS
      {
         isIPAddressBlacklisted: <boolean>
      }
 */
export const validateIP = () => {
   return from(
      axios.get(global.API_URL + "/search/validate.fsn?CID=2420&OID=3191")
   ).pipe(
      first(),
      map(({data}) => {
         return {
            isIPAddressBlacklisted: data && stringHasKeywordRejected(data)
         };
      }), catchError(error => {
         console.log('error: ', error);
         return of(error);
      }));
};

/*

   <(^_^)> Bryan Perez
   Legacy

*/

export const validateInternational = () => {
   return from(
      axios.get(global.API_URL + "/search/validate.fsn?CID=2420&OID=3173")
   ).pipe(
      first(),
      map(({data}) => {
         return {
            isValidInternational: data && stringHasKeywordSuccess(data)
         };
      }), catchError(error => {
         console.log('error: ', error);
         return of(error);
      }));
};

/*

   <(^_^)> Bryan Perez

   Returns a map.
   Where the keys are the field name that is being verified
   and the values are boolean that indicates if the field is valid

   Empty string values for fname, lname, or email is considered invalid

   RETURNS
      {
         isFnameValid: <isFnameValid>
         isLnameValid: <isLnameValid>
         isEmailValid: <isEmailValid>
      }
 */


const fnameLnameEmailDefaultValues = (value) => (
   {
      isFnameValid: value,
      isLnameValid: value,
      isEmailValid: value,
   }
);
export const validateFnameLnameEmail = (fname, lname, email) => {
   return from(
      axios.get(global.API_URL + `/search/validate.fsn?CID=2420&OID=3152&fname=${fname}&lname=${lname}&email=${email}`)
   ).pipe(
      first(),
      map(({data}) => {
         if (!data) {
            return fnameLnameEmailDefaultValues(false);
         } else {
            const keywordsMap = stringHasKeywords(data, ["rejected", "success", "fname", "lname", "email"]);
            if (keywordsMap.success) {
               return fnameLnameEmailDefaultValues(true);
            } else {

               const retval =  ({
                  isFnameValid: !keywordsMap.fname,
                  isLnameValid: !keywordsMap.lname,
                  isEmailValid: !keywordsMap.email
               });

               console.log("validate fname, lname, email retval=", retval);
               return ({
                  isFnameValid: !keywordsMap.fname,
                  isLnameValid: !keywordsMap.lname,
                  isEmailValid: !keywordsMap.email
               });
            }
         }
      }), catchError(error => {
         console.log('error: ', error);
         return of(error);
      }));
};

/*

   <(^_^)> Bryan Perez

   RETURNS

   {
      isCompanyNameBlacklisted: <boolean>
   }

*/
export const validateCompanyName = (companyName) => {
   return from(
      axios.get(global.API_URL + `/search/validate.fsn?CID=2420&OID=3194&companyName=${companyName}`)
   ).pipe(
      first(),
      map(({data}) => {
         const keywordsMap = stringHasKeywords(data, ["rejected"]);
         return ({
            isCompanyNameBlacklisted: keywordsMap.rejected
         })
      }), catchError(error => {
         console.log('error: ', error);
         return of(error);
      }));
};


/*

   <(^_^)> Bryan Perez

   Checks if keywords in the string exists; case-insensitive
   keywords are all converted to lowercase as keys of the map


   EX:
      INPUT
         str = "Hey there im a cow. Moo"
         keywords = ["cOw", "doggo"]

      OUTPUT
         {
            cow: true,
            doggo: false
         }
 */
const stringHasKeywords = (str, keywords) => {
   if (!keywords || keywords.length < 1) {
      return {};
   } else if (!str || str.length < 1) {
      let obj = {};
      keywords.forEach(keyword => {
         const keywordLowerCase = keyword && keyword.toLowerCase();
         if (keywordLowerCase) {
            obj[keywordLowerCase] = false;
         }
      });
      return obj;
   } else {
      let obj = {};
      const strLowerCase = str.toLowerCase();
      keywords.forEach(keyword => {
         const keywordLowerCase = keyword && keyword.toLowerCase();
         if (keywordLowerCase) {
            obj[keywordLowerCase] = strLowerCase.indexOf(keywordLowerCase) > -1;
         }
      });

      return obj;
   }
};

const stringHasKeywordSuccess = (data) => {
   return data && data.toLowerCase().indexOf('success') > -1;
};

const stringHasKeywordRejected = (data) => {
   return data && data.toLowerCase().indexOf('rejected') > -1;
};